( function ( ) {
	'use strict';

	/* @ngInject */
	function noteView ( $q, coreservice, logger, $timeout, moment ) {
		function link ( scope, element ) {
			scope.showEdit    = false;
			scope.editOptions = false;
			scope.isCollapsed = true;
			// change time format for timestamp
			scope.timestamp = moment( scope.note.timestamp ).format( 'MM/DD/YY hh:mm A' );

			scope.focusTextarea = function () {
				scope.script      = angular.copy( scope.note.name );
				scope.editOptions = true;
			};

			function highlightScript () {
				scope.$root.$broadcast( 'unselect:script' );
				element.find( '.note' ).addClass( 'selected-script' );
			}

			function changeList () {
				scope.$root.$broadcast( 'change:list', scope.note );
			}

			scope.selectScript = function () {
				if ( !scope.$parent.$parent.vm.attachMode ) {
					scope.focusTextarea();
				} else {
					changeList();
					highlightScript();
				}
			};

			function changeScript () {
				scope.editOptions = false;

				if ( scope.note.name !== scope.script ) {
					scope.note.name = scope.script;
					scope.$emit( 'update:script' );
				}
			}

			function checkEnter ( ev ) {
				if ( ev.keyCode === 13 && !ev.shiftKey ) {
					ev.preventDefault();
					// this to prevent submitting empty string
					if ( scope.script !== '' ) {
						changeScript();
					}
				}
			}

			function deleteNote () {
				scope.delDisable = !scope.delDisable;
				$timeout( function () {
					scope.$emit( 'deleteNote', scope.note );
					scope.$root.$broadcast( 'update:tree:list' );
				}, 0 );
			}

			scope.checkEnter = checkEnter;
			scope.deleteNote = deleteNote;

			scope.$on( 'select:script', function ( ev, id ) {
				if ( scope.note.id === id ) {
					highlightScript();
				}
			} );

			scope.$on( 'unselect:script', function () {
				element.find( '.note' ).removeClass( 'selected-script' );
			} );
		}

		var directive = {
			'link'        : link,
			'restrict'    : 'E',
			'templateUrl' : '/templates/components/evidences/script/note-view.html',
			'scope'       : {
				'note'       : '=',
				'update'     : '&',
				'delDisable' : '=?'
			}
		};

		return directive;
	}

	angular
		.module( 'app.components' )
		.directive( 'noteView', noteView );
	noteView.$inject = [ '$q', 'coreservice', 'logger', '$timeout', 'moment' ];
} )( );
